var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{ref:"axisX",attrs:{"data-role":"AxisX","transform":("translate(" + (_vm.CHART_SIZE.marginLeft) + ", 0)")}})}
var staticRenderFns = []

export { render, staticRenderFns }